import dayjs from "dayjs";
import { EmptyState } from "@/components/widgets";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import {
  Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { ImageDown, Loader2, Printer } from "lucide-react";
import { DailyReportCard, KIND_LABEL } from "./DailyReportCard";

export const ReportToolbar = ({ date, dates, loadReports, selectedKey, setSelectedKey, reports, grouped, current, downloading, downloadImage }) => (
  <Card className="p-3 mb-5">
    <div className="flex flex-wrap gap-2 items-center">
      <Select value={date || ""} onValueChange={(v) => loadReports(v)}>
        <SelectTrigger className="h-9 w-[190px]" data-testid="daily-report-date-select">
          <SelectValue placeholder="Select date" />
        </SelectTrigger>
        <SelectContent>
          {dates.map((d) => (
            <SelectItem key={d} value={d}>{dayjs(d).format("ddd, D MMM YYYY")}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      {reports.length > 1 && (
        <Select value={selectedKey || ""} onValueChange={setSelectedKey}>
          <SelectTrigger className="h-9 w-[250px]" data-testid="daily-report-scope-select">
            <SelectValue placeholder="Select scope" />
          </SelectTrigger>
          <SelectContent className="max-h-72">
            {grouped.map((g) => (
              <SelectGroup key={g.kind}>
                <SelectLabel>{KIND_LABEL[g.kind]}</SelectLabel>
                {g.items.map((r) => (
                  <SelectItem key={r.scope_key} value={r.scope_key}>{r.title}</SelectItem>
                ))}
              </SelectGroup>
            ))}
          </SelectContent>
        </Select>
      )}
      <div className="flex gap-2 ml-auto">
        <Button variant="outline" size="sm" onClick={() => window.print()} disabled={!current} data-testid="daily-report-print-button">
          <Printer size={14} className="mr-1.5" /> PDF / Print
        </Button>
        <Button variant="outline" size="sm" onClick={downloadImage} disabled={!current || downloading} data-testid="daily-report-image-button">
          {downloading ? <Loader2 size={14} className="animate-spin mr-1.5" /> : <ImageDown size={14} className="mr-1.5" />}
          Image card
        </Button>
      </div>
    </div>
  </Card>
);

/* Loading / empty / data states without nested ternaries. */
export const ReportView = ({ loading, current, isAdminOrMd, cardRef, navigate }) => {
  if (loading) {
    return <div className="dr-card-wrap"><Skeleton className="h-[480px] rounded-[14px]" /></div>;
  }
  if (!current) {
    return (
      <Card>
        <EmptyState
          title="No daily reports yet"
          subtitle={isAdminOrMd ? "Reports are generated automatically after each upload — or click Generate now." : "Your daily report appears after the evening upload is processed."}
        />
      </Card>
    );
  }
  return (
    <div className="dr-card-wrap dr-print-area" ref={cardRef}>
      <div className="dr-scope-tag" data-testid="daily-report-scope-tag">
        {KIND_LABEL[current.kind]} · {current.title} · {dayjs(current.date).format("D MMM YYYY")}
      </div>
      <DailyReportCard r={current} onOpenDashboard={() => navigate("/")} />
    </div>
  );
};
